async function lmAddToCart(btn, variantId, qty) {
  qty = qty || 1;
  const orig = btn.textContent;
  btn.disabled = true;
  btn.classList.add('lm-atc--loading');
  btn.textContent = '...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!res.ok) throw new Error();

    btn.textContent = '✓ Added';
    btn.classList.remove('lm-atc--loading');
    btn.classList.add('lm-atc--added');
    lmUpdateCartCount();

    setTimeout(() => {
      btn.textContent = orig;
      btn.classList.remove('lm-atc--added');
      btn.disabled = false;
    }, 1600);

  } catch {
    btn.textContent = 'Error';
    btn.classList.remove('lm-atc--loading');
    btn.style.background = '#c62828';
    setTimeout(() => {
      btn.textContent = orig;
      btn.style.background = '';
      btn.disabled = false;
    }, 2000);
  }
}

async function lmUpdateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const n = cart.item_count;
    document.querySelectorAll(
      '.cart-count-bubble span[aria-hidden], [data-cart-count], .cart__count'
    ).forEach(el => {
      el.textContent = n;
      if (n > 0) el.closest('[hidden]')?.removeAttribute('hidden');
    });
  } catch {}
}